// import { milestoneDateDisplay, milestoneHasValue } from '../../helper/formatDateOnly';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

import glassWidgetHelpers from 'helpers/glassWidgetsHelpers';

import GlassCard from '../../GlassCard';

// import { GlassCard } from '../../GlassCard/GlassCard';

const formatRevenueUsd = (amount) =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);

/** @param rewards */
const revenueUsdOrNull = (rewards) => {
  const h = rewards.highlight?.value;
  if (h !== undefined && h !== null && !Number.isNaN(h)) return h;
  const r = rewards.totals?.revenue_usd;
  if (r !== undefined && r !== null && !Number.isNaN(r)) return r;
  return null;
};

/** @param rewards */
const hasReportedRevenue = (rewards) => {
  const n = revenueUsdOrNull(rewards);
  return n !== null && !Number.isNaN(n) && n !== 0;
};

/** @param rewards */
export const achievementsHasAnyStatRow = (rewards) => {
  if (glassWidgetHelpers.milestoneHasValue(rewards.last_entry_display, rewards.last_entry_at)) return true;
  if (rewards.total_entries > 0) return true;
  if (hasReportedRevenue(rewards)) return true;
  return false;
};

/** @param panel */
export const achievementsCardShouldMount = (panel) => {
  if (panel.loading) return true;
  if (panel.loadError) return true;
  if (panel.rewards === null) return false;
  return achievementsHasAnyStatRow(panel.rewards);
};

const headerExtra = (
  <span className="achievements-card__header-star" aria-hidden>
    <FontAwesomeIcon icon={['fas', 'treasure-chest']} />
  </span>
);

/**
 * @param root0
 * @param root0.span
 * @param root0.variant
 * @param root0.addContentGutter
 * @param root0.achievements
 * @param root0.lightTheme
 */
const AchievementsCard = ({ span, variant, addContentGutter, achievements, lightTheme = false }) => {
  const { loading, loadError, rewards } = achievements;

  if (!loading && !loadError && (rewards === null || !achievementsHasAnyStatRow(rewards))) {
    return null;
  }

  const hasLastBooking =
    rewards !== null && glassWidgetHelpers.milestoneHasValue(rewards.last_entry_display, rewards.last_entry_at);
  const lastBookingDisplay = glassWidgetHelpers.milestoneDateDisplay(
    rewards?.last_entry_display,
    rewards?.last_entry_at,
  );

  const hasContestEntries = rewards !== null && rewards.total_entries > 0;
  const contestEntriesDisplay = rewards?.total_entries ?? 0;

  const revenueAmount = rewards !== null ? revenueUsdOrNull(rewards) : null;
  const hasRevenue = rewards !== null && hasReportedRevenue(rewards);
  const highlightLabel = rewards?.highlight?.label?.trim();
  const totalRevenueLabel =
    highlightLabel !== undefined && highlightLabel !== ''
      ? highlightLabel
      : i18n.translate('glassWidgets.achievements.totalRevenue');
  const totalRevenueDisplay = hasRevenue && revenueAmount !== null ? formatRevenueUsd(revenueAmount) : '';

  const hasStatsList = hasLastBooking || hasContestEntries || hasRevenue;

  return (
    <GlassCard
      title={i18n.translate('glassWidgets.achievements.title')}
      headerExtra={headerExtra}
      span={span}
      variant={variant}
      addContentGutter={addContentGutter}
      lightTheme={lightTheme}
      className="achievements-card"
    >
      {loading && <p className="achievements-card__loading">{i18n.translate('glassWidgets.achievements.loading')}</p>}

      {!loading && loadError && <p className="achievements-card__loading">{loadError}</p>}

      {!loading && !loadError && hasStatsList && (
        <div className="achievements-card__content">
          <ul className="achievements-card__stats">
            {hasLastBooking && (
              <li className="achievements-card__stat-item">
                <span className="achievements-card__stat-label">
                  {i18n.translate('glassWidgets.achievements.lastBooking')}
                </span>
                <span className="achievements-card__stat-value">{lastBookingDisplay}</span>
              </li>
            )}
            {hasContestEntries && (
              <li className="achievements-card__stat-item">
                <span className="achievements-card__stat-label">
                  {i18n.translate('glassWidgets.achievements.contestEntries')}
                </span>
                <span className="achievements-card__stat-value">{contestEntriesDisplay}</span>
              </li>
            )}
            {hasRevenue && (
              <li className="achievements-card__stat-item">
                <span className="achievements-card__stat-label">{totalRevenueLabel}</span>
                <span className="achievements-card__stat-value">{totalRevenueDisplay}</span>
              </li>
            )}
          </ul>
        </div>
      )}
    </GlassCard>
  );
};

export default AchievementsCard;
